import { render, staticRenderFns } from "./ExpertForm.vue?vue&type=template&id=451a078b&scoped=true&"
import script from "./ExpertForm.vue?vue&type=script&lang=js&"
export * from "./ExpertForm.vue?vue&type=script&lang=js&"
import style0 from "./ExpertForm.vue?vue&type=style&index=0&id=451a078b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a078b",
  null
  
)

export default component.exports